import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-botao-scroll',
    templateUrl: './botao-scroll.component.html',
    styleUrls: ['./botao-scroll.component.scss'],
    standalone: false
})
export class BotaoScrollComponent implements OnInit, OnChanges {

  cssClass: String = "scroll-button-not-fixed"
  @Input() rodapeVisivel : boolean = false;
  changeCss() {
    if (this.rodapeVisivel) {
      this.cssClass = "scroll-button-not-fixed";
    }
    else {
      this.cssClass = "scroll-button-fixed"
    }
  }

  scrollTop() {
    document.documentElement.scrollIntoView({behavior:"smooth"})
  }

  constructor() { }

  ngOnChanges(_changes: SimpleChanges): void {
    this.changeCss();
  }

  ngOnInit(): void {
    this.changeCss();
  }

}
